@let _item = item();

@switch (_item.type) {
    @case ('link') {
        <a
            class="item"
            [routerLink]="_item.disabled ? null : [{ outlets: { primary: _item.route, mobile: null } }]"
            [relativeTo]="root"
            routerLinkActive="active"
            #rla="routerLinkActive"
            role="menuitem"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            [class.disabled]="_item.disabled"
            [attr.data-test]="_item.testId"
        >
            <app-icon [icon]="_item.icon" [size]="16" />
            <span>{{ _item.skipLabelTranslation ? _item.label : (_item.label | translate) }}</span>
        </a>
    }

    @case ('outlet') {
        <div routerLinkActive="active" #outletRla="routerLinkActive">
            @if (_item.activeRoute) {
                <a [routerLink]="_item.activeRoute" [relativeTo]="root" class="hidden" aria-hidden="true" tabindex="-1"></a>
            }

            <a
                class="item"
                [routerLink]="[{ outlets: _item.outlets }]"
                [relativeTo]="root"
                role="menuitem"
                [attr.aria-current]="outletRla.isActive ? 'page' : null"
                [attr.data-test]="_item.testId"
            >
                <app-icon [icon]="_item.icon" [size]="16" />
                <span>{{ _item.skipLabelTranslation ? _item.label : (_item.label | translate) }}</span>
            </a>
        </div>
    }

    @case ('submenu') {
        <div routerLinkActive #rla="routerLinkActive">
            <button
                class="item"
                type="button"
                role="menuitem"
                aria-haspopup="true"
                [attr.aria-expanded]="isOpen() || rla.isActive"
                [attr.aria-controls]="submenuId"
                [class.active]="rla.isActive"
                (click)="toggle()"
                [attr.data-test]="_item.testId"
            >
                <app-icon [icon]="_item.icon" [size]="16" />
                <span>{{ _item.skipLabelTranslation ? _item.label : (_item.label | translate) }}</span>
            </button>

            <ul role="menu" [id]="submenuId" [class.open]="isOpen() || rla.isActive">
                @for (child of _item.children; track child.route) {
                    <li role="none">
                        <a
                            [routerLink]="[{ outlets: { primary: child.route, mobile: null } }]"
                            [relativeTo]="root"
                            routerLinkActive="active"
                            #childRla="routerLinkActive"
                            role="menuitem"
                            [attr.aria-current]="childRla.isActive ? 'page' : null"
                            [attr.data-test]="child.testId"
                        >
                            <span>{{ child.skipLabelTranslation ? child.label : (child.label | translate) }}</span>
                        </a>
                    </li>
                }
            </ul>
        </div>
    }
}
